import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { FlowInstanceService } from '../../flow/services/flow-instance.service';
import { FlowInstance } from '../../flow/models/flow.model';

@Injectable()
export class ReportResolver  {

    constructor(public service: FlowInstanceService) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): FlowInstance | Observable<FlowInstance> | Promise<FlowInstance> {
        return this.service.get(route.params.id);
    }
}
